/**
 * Shown when Dynamics is unreachable (FEDEV-528).
 *
 * One component, one form of words, used wherever it happens. The portal is
 * largely a window onto Dynamics — deliveries, holidays, prices and payment
 * details all come from it — so when it is down there is very little a
 * customer can usefully do. Saying so plainly beats letting them in to an app
 * that fails on every screen, and it stops support fielding calls that look
 * like bugs but are an outage.
 *
 * Deliberately does not blame the customer or ask them to check anything:
 * there is nothing they can do differently, and the wording should not imply
 * otherwise.
 */
interface Props {
  /** Server's wording where we have it, so one place governs the message. */
  message?: string
  /** Shown when the caller can retry without a page reload. */
  onRetry?: () => void
}

export default function OutageNotice({ message, onRetry }: Props) {
  return (
    <div className="alert alert-warning" role="status">
      <p>
        {message ||
          'We are having trouble reaching our systems right now. Please try again in a few minutes.'}
      </p>
      <p className="form-text">
        Nothing is wrong with your account and you do not need to do anything.
      </p>
      {onRetry && (
        <button type="button" className="btn btn-link" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  )
}
